module.exports = __webpack_public_path__ + "static/media/icon_120.6717ebd5.svg";